import { services } from "@/data/content";
import * as Icons from "lucide-react";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="border-t border-neutral-800">
      <div  className={`max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 `}>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-6">
            <p className="overline mb-4">What I Handle — For You</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight">
              Research, negotiation and due diligence — <span className="italic text-[#36C281]">end to end</span>.
            </h2>
          </div>
          <p className="md:col-span-5 md:col-start-8 text-neutral-400 leading-relaxed">
            I handle the entire buying process so you can stay focused on what matters — building the portfolio, not chasing it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border border-neutral-800">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Square;
            return (
              <div
                key={s.title}
                data-testid={`service-${i}`}
                className="p-10 border-neutral-800 border-b md:border-b md:border-r last:border-r-0 hover:bg-[#FFFFFF] transition-colors duration-300 group"
                style={{
                  borderRightWidth: (i + 1) % 3 === 0 ? 0 : undefined
                }}
              >
                <Icon size={28} className="text-[#36C281] mb-8" strokeWidth={1.25} />
                <h3 className="font-serif-display text-2xl mb-4">{s.title}</h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
